// ============================================================
// THE SQUAD MODE HOUSE RULES' CHOICES (Squad Mode stage 6, ruled
// 2026-10-23): what a failed Cohesion Challenge does. Kept beside the rules
// they govern; the registry row and the resolver read them.
//
// Pure. Zero React dependency.
// ============================================================

export type ChallengeFailure = 'nothing' | 'nextTurn';

export const CHALLENGE_FAILURES: { key: ChallengeFailure; label: string; hint: string }[] = [
  {
    key: 'nothing',
    label: 'Nothing happens',
    hint: 'He stays in Solo Mode and may try again; the Challenge cost nothing.',
  },
  {
    key: 'nextTurn',
    label: 'He enters at his next turn',
    hint: 'His entry waits for his next turn start, and takes that turn - unless no brother is in range by then.',
  },
];

export const DEFAULT_CHALLENGE_FAILURE: ChallengeFailure = 'nothing';

export const isChallengeFailure = (v: unknown): v is ChallengeFailure => v === 'nothing' || v === 'nextTurn';
